import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import { spokenChange } from "./deltaFormat";

const icons = {
  up: ArrowUpOutlined,
  down: ArrowDownOutlined,
  none: MinusOutlined,
};

// The arrow and amount people see, plus the sentence a screen reader announces instead.
const ChangeLabel = ({
  change,
  comparison,
  isPercentage,
  value,
  earlierValue,
}) => {
  const Icon = icons[change.direction];

  return (
    <>
      <span className="change-visible" aria-hidden="true">
        <Icon style={{ fontSize: 10 }} />
        {change.text}
      </span>
      <span className="sr-only">
        {spokenChange({ change, comparison, isPercentage, value, earlierValue })}
      </span>
    </>
  );
};

export default ChangeLabel;
